import { Reducer } from 'redux';
import _ from 'lodash';
import { IReduxAction } from 'app/types/actions';
import {
  ConnectionRunsActionTypes as types,
  IConnectionRunsState,
} from './types';

const initialState: IConnectionRunsState = {
  connectionRunsById: {},
  connectionRunIds: [],
  currentConnectionRunId: undefined,
  isLoading: false,
  isSaving: false,
  hasLoaded: false,
  hasSaved: false,
  hasFailed: false,
  requestedData: {},
  backendErrors: {},
  filterConfig: {},
  sortConfig: {},
  pagination: {
    page: {
      size: 5000,
      number: 0,
    },
    filter: [],
    sort: [],
    meta: {
      totalCount: undefined,
      totalPages: undefined,
    },
  },
};

const reducer: Reducer<IConnectionRunsState> = (
  state = initialState,
  action: IReduxAction,
) => {
  switch (action.type) {
    case types.GET_ALL_CONNECTION_RUNS_PENDING: {
      return {
        ...state,
        isLoading: true,
        hasLoaded: false,
        pagination: {
          ...initialState.pagination,
          ...action.payload.pagination,
        },
      };
    }
    case types.GET_ALL_CONNECTION_RUNS_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        hasLoaded: true,
        connectionRunsById: action.payload.connectionRunsById,
        connectionRunIds: action.payload.connectionRunIds,
        pagination: {
          ...state.pagination,
          meta: action.payload.meta,
        },
      };
    }
    case types.GET_ALL_CONNECTION_RUNS_FAIL: {
      return {
        ...state,
        isLoading: false,
        backendErrors: action.payload.backendErrors,
      };
    }
    case types.GET_CONNECTION_RUN_PENDING: {
      return {
        ...state,
        isLoading: true,
        hasLoaded: false,
      };
    }
    case types.GET_CONNECTION_RUN_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        connectionRunsById: _.merge(
          {},
          state.connectionRunsById,
          action.payload.connectionRunsById,
        ),
        connectionRunIds: _.union(state.connectionRunIds, [
          action.payload.currentConnectionRunId,
        ]),
        currentConnectionRunId: action.payload.currentConnectionRunId,
      };
    }
    case types.GET_CONNECTION_RUN_FAIL: {
      return {
        ...state,
        isLoading: false,
        backendErrors: action.payload.backendErrors,
      };
    }
    case types.SELECT_CONNECTION_RUN_REQUESTED: {
      return {
        ...state,
        currentConnectionRunId: action.payload.currentConnectionRunId,
      };
    }
    case types.UPDATE_CONNECTION_RUN_PENDING: {
      return {
        ...state,
        isSaving: true,
        hasSaved: false,
        hasFailed: false,
        requestedData: action.payload,
        backendErrors: {},
      };
    }
    case types.UPDATE_CONNECTION_RUN_SUCCESS: {
      return {
        ...state,
        isSaving: false,
        hasSaved: true,
        requestedData: {},
        connectionRunsById: _.merge(
          {},
          state.connectionRunsById,
          action.payload.connectionRunsById,
        ),
        connectionRunIds: _.union(state.connectionRunIds, [
          action.payload.currentConnectionRunId,
        ]),
        currentConnectionRunId: action.payload.currentConnectionRunId,
        hasLoaded: false,
      };
    }
    case types.UPDATE_CONNECTION_RUN_FAIL: {
      return {
        ...state,
        isSaving: false,
        backendErrors: action.payload.backendErrors,
      };
    }
    case types.CREATE_CONNECTION_RUN_PENDING: {
      return {
        ...state,
        isSaving: true,
        hasSaved: false,
        hasFailed: false,
        requestedData: action.payload,
        backendErrors: {},
      };
    }
    case types.CREATE_CONNECTION_RUN_SUCCESS: {
      return {
        ...state,
        isSaving: false,
        hasSaved: true,
        requestedData: {},
        connectionRunsById: _.merge(
          {},
          state.connectionRunsById,
          action.payload.connectionRunsById,
        ),
        connectionRunIds: _.union(state.connectionRunIds, [
          action.payload.currentConnectionRunId,
        ]),
        currentConnectionRunId: action.payload.currentConnectionRunId,
        backendErrors: {},
      };
    }
    case types.CREATE_CONNECTION_RUN_FAIL: {
      return {
        ...state,
        isSaving: false,
        backendErrors: action.payload.backendErrors,
      };
    }
    case types.DELETE_CONNECTION_RUN_PENDING: {
      return {
        ...state,
        isSaving: true,
        hasSaved: false,
        hasFailed: false,
      };
    }
    case types.DELETE_CONNECTION_RUN_SUCCESS: {
      return {
        ...state,
        isSaving: false,
        hasSaved: true,
        requestedData: {},
        connectionRunsById: _.omit(
          state.connectionRunsById,
          action.payload.currentConnectionRunId,
        ),
        connectionRunIds: _.without(
          state.connectionRunIds,
          action.payload.currentConnectionRunId,
        ),
        currentConnectionRunId: undefined,
        hasLoaded: false,
      };
    }
    case types.DELETE_CONNECTION_RUN_FAIL: {
      return {
        ...state,
        isSaving: false,
        hasFailed: true,
        backendErrors: action.payload.backendErrors,
      };
    }
    default:
      return state;
  }
};

export default reducer;
